/*
 * Tabs script
 */
class P_Tabs {
    constructor(wrapper) {
        this.wrapper = $(wrapper);
        this.initState();
        this.initEvents();
    }

    initState() {
        this.currentIndex = 0;
        this.win = jQuery(window);
        this.tabs = this.wrapper.find('.tablinks-wrapper .tablinks');
        this.contents = this.wrapper.find('.tabcontent-wrapper .tabcontent');
    }

    initEvents() {
        let self = this;

        for (let i = 0; i < this.tabs.length; i++) {
            this.tabs.eq(i).on('click', function () {
                self.tabs.removeClass('active');
                self.contents.removeClass('active');
                let nextIndex = parseInt($(this).attr('data-index'), 10);
                this.currentIndex = nextIndex;
                self.tabs.eq(nextIndex).addClass('active');
                self.contents.eq(nextIndex).addClass('active');
                $(window).trigger('resize');
            });
        }
    }
}